export default __webpack_public_path__ + "static/1990_2000-cdeb9bb6f6af01f28ccae080b0ddf080.mp4";